import React, { PureComponent } from 'react';
import { Container } from 'react-bootstrap';
import Stepper from '../../../components/Stepper';
import Header from '../../../components/Header';
import Result from './components/Result';

class ResultContainer extends PureComponent {
  render() {
    const { simulationSelected } = this.props.location.state;
    return (
      <React.Fragment>
        <Header />
        <Container fluid className="dap_no-padding">
          <Stepper />
          <Result simulationSelected={simulationSelected} />

        </Container>
      </React.Fragment>
    );
  }
}

export default ResultContainer;
